export const isLinkBooleanish = (value, trueValues = []) => {
  if (value === true || value === 1) {
    return true
  }

  if (value === false || value === null || value === undefined) {
    return false
  }

  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase()

    if (normalized === "" || normalized === "false" || normalized === "0") {
      return false
    }

    if (normalized === "true" || normalized === "1") {
      return true
    }

    return trueValues.includes(normalized)
  }

  return Boolean(value)
}

export const getLinkTarget = (value) => {
  if (value === true || value === 1) {
    return "_blank"
  }

  if (value === false || value === null || value === undefined) {
    return null
  }

  if (typeof value === "string") {
    const trimmed = value.trim()

    if (trimmed === "") {
      return null
    }

    const normalized = trimmed.toLowerCase()

    if (
      normalized === "false" ||
      normalized === "0" ||
      normalized === "_self"
    ) {
      return null
    }

    if (
      normalized === "true" ||
      normalized === "1" ||
      normalized === "_blank"
    ) {
      return "_blank"
    }

    return trimmed
  }

  return value ? "_blank" : null
}

export const isLinkTargetBlank = (value) => getLinkTarget(value) === "_blank"

export const getLinkRel = ({ nofollow, sponsored } = {}) => {
  const parts = []

  if (isLinkBooleanish(nofollow, ["nofollow"])) {
    parts.push("nofollow")
  }

  if (isLinkBooleanish(sponsored, ["sponsored"])) {
    parts.push("sponsored")
  }

  return parts.length ? parts.join(" ") : null
}

export const getAnchorAttrsFromLink = (link = {}) => {
  const target = getLinkTarget(link.target)
  const rel = getLinkRel(link)

  return Object.fromEntries(
    Object.entries({
      href: link.url,
      target,
      rel
    }).filter(([, value]) => value !== null && value !== "")
  )
}
